"use client";

import Link from "next/link";
import Image from "next/image";
import styles from "./Footer.module.css";
import { FooterProps } from "./Footer.props";
import { FormattedMessage } from "react-intl";
import { AppConstants } from "@/app/constants";
import { AppNav } from "@/app/app-nav";
import { resolveGuiVersionLabel } from "@/app/shared/site-version";
import TermsModalLink from "@/components/terms/TermsModalLink";

export default function Footer({
  aboutVariant = "public",
  ...props
}: FooterProps) {
  const guiVersionLabel = resolveGuiVersionLabel();
  const aboutHref =
    aboutVariant == "site" ? `/${AppNav.About}` : `/${AppNav.AboutPublic}`;

  return (
    <footer {...props}>
      <div className={styles.wrapper}>
        <p>
          <strong>{AppConstants.PoolName}</strong>{" "}
          <Link className={styles.footerLinks} href={aboutHref}>
            <FormattedMessage id="footer-about" />
          </Link>
        </p>
        <p className={styles.termsText}>
          <FormattedMessage
            id="footer-desc"
            values={{
              link: (
                <TermsModalLink
                  className={styles.footerLinks}
                  key="footer-link"
                >
                  <FormattedMessage id="footer-terms" />
                </TermsModalLink>
              ),
            }}
          />
        </p>
        <p className={styles.sourceLink}>
          GUI{" "}
          <Link
            className={styles.footerLinks}
            href="https://github.com/ZULUPooL/zulupool-frontend"
          >
            {`v${guiVersionLabel}`}
          </Link>{" "}
          PoolCore{" "}
          <Link
            className={styles.footerLinks}
            href="https://github.com/eXtremal-ik7/poolcore"
          >
            v0.9999b
          </Link>
        </p>
        <p className={styles.dataSource}>
          <span>
            <FormattedMessage id="footer-market-data-source" />
          </span>
          <Link
            className={styles.coinGeckoLink}
            href="https://www.coingecko.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="CoinGecko"
          >
            <Image
              className={styles.coinGeckoLogo}
              src="/icons/footer/CG-Lockup-2.svg"
              alt="CoinGecko"
              width={108}
              height={24}
            />
          </Link>
        </p>
      </div>
    </footer>
  );
}
